// extracted by mini-css-extract-plugin
module.exports = {"container":"checkout_container__uELr5","inputCheckbox":"checkout_inputCheckbox__KjiSX","inputRadio":"checkout_inputRadio__Ftn0A"};